import { useEffect, useRef, useState } from 'react';
import { ProTableOt, Toaster, toast, Row, Col, Button, useProTableOt, Form, Modal, message, Input, Typography } from '../../ui/ot'
import { useBorrower } from '../controllers/BorrowerController';
import { useCheckoutHistory } from '../controllers/CheckoutHistoryController';
import dayjs from 'dayjs'
import { Link } from 'react-router-dom';
import { useCheckin } from '../controllers/CheckinController';
import { useTranslation } from 'react-i18next';
import axios from 'axios'

const CheckoutsProTableOt = ({
    propsForm,
    fieldName,
    hasValue = false,
    keyPrefix = "library.backstage.Circulation.CheckOut.borrowed_list",
    borrowernumber,
    itemnumber,
    barcode,
    biblionumber,
    toolBarRender = (tools) => ([...tools]),
    propsOnFinish = () => { }, 
    permission_level = null, 
    defaultOrder = [],
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const actionRef = useRef()
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [search, setSearch] = useState({
        date_issue_start: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        date_issue_end: dayjs().format('YYYY-MM-DD'),
    })
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const columns = [
        // {
        //     title: t("due_date"),
        //     dataIndex: 'issue_date_due',
        //     key: 'issue_date_due',
        //     render: (text) => {
        //         return <>{dayjs(text).format('YYYY-MM-DD')}</>
        //     }
        // },
        {
            title: t("borrowernumber"),
            dataIndex: 'issue_borrower_cardnumber',
            key: 'issue_borrower_cardnumber',
            // render: (text) => {
            //     return <>{dayjs(text).format('YYYY-MM-DD')}</>
            // }
        },
        {
            title: t("issue_borrowername"),
            dataIndex: 'staff_name',
            key: 'staff_name',
            render: (text, record) => {
                return <>
                    <Row>
                        <Col span={24}>{record?.staff_name}</Col>
                        <Col span={24}>{record?.staff_english_name}</Col>
                    </Row>
                </>
            }
        },
        {
            title: t("title"),
            dataIndex: 'bib_title',
            key: 'bib_title',
            render: (text, record) => {
                return <>
                    <Row>
                        <Col span={24}>{record?.item_barcode}</Col>
                        <Col span={24}>{text}</Col>
                        <Col span={24}>{record?.bib_subtitle}</Col>
                        <Col span={24}>{record?.bib_author}</Col>
                    </Row>
                </>
            }
        },
        {
            title: t("category"),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        // {
        //     title: t("collection"),
        //     dataIndex: 'collection',
        //     key: 'collection',
        // },
        // {
        //     title: t("location"),
        //     dataIndex: 'item_location',
        //     key: 'item_location',
        // },
        {
            title: t("original_library"),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t("borrow_library"),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t("borrow_date"),
            dataIndex: 'issue_issuedate',
            key: 'issue_issuedate',
        },
        // {
        //     title: t("return_branch"),
        //     dataIndex: 'item_branchname_home',
        //     key: 'return_branch',
        // },
        // {
        //     title: t("return_time"),
        //     dataIndex: 'item_branchname_holding',
        //     key: 'return_time',
        // },
        // {
        //     title: t("note"),
        //     dataIndex: 'issue_issuedate',
        //     key: 'note',
        // },
        // {
        //     title: t("fee"),
        //     dataIndex: 'issue_charge',
        //     key: 'issue_charge',
        // },
        // {
        //     title: t("fine"),
        //     dataIndex: 'issue_accountlines_amount',
        //     key: 'issue_accountlines_amount',
        // },
        // {
        //     title: t("price"),
        //     dataIndex: 'item_purchase_price',
        //     key: 'item_purchase_price',
        // },
        // {
        //     title: t("action"),
        //     dataIndex: 'returnBook',
        //     key: 'returnBook',
        //     render: (_, record) => {
        //         return <>
        //             <Row gutter={[8, 8]}>
        //                 <Col>
        //                     <Button variant="destructive" onClick={() => CheckIn({ record })}>{t("return")}</Button>
        //                 </Col>
        //                 <Col>
        //                     <Button variant="outline" disabled={record?.issue_renewals_allow === record?.issue_renewals_count} onClick={() => Renew({ record })}>{t("renew")}</Button>
        //                 </Col>
        //             </Row>
        //         </>
        //     }
        // },
    ];

    const setParamsFilter = (obj) => {
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const onBefore = (value) => {
        console.log('onBefore', value)
    }
    const onFinish = (value) => {
    }
    const Renew = ({ record }) => {
        let RenewArray = (record ? [record] : selectedRowsInfo).map((row) => {
            return {
                "issue_id": row?.issue_id,  //row.issue_id
            }
        })
        postCheckoutRenewData(RenewArray)
    }
    const CheckIn = ({ record }) => {
        let CheckInArray = (record ? [record] : selectedRowsInfo).map((row) => {
            return {
                "itemnumber": row?.item_itemnumber,  //row.issue_id
                "borrowernumber": row?.issue_borrowernumber,
                // "branchcode": row?.issue_branchcode,
                "branchcode": row?.item_branchcode_home,
            }
        })
        postCheckinData(CheckInArray)
    }

    const onValuesChange = (e, { name, ...props }) => {
    }
    const onRecordDelteFinish = ({ axiosMode, status, values }) => {
        propsOnFinish({ axiosMode, status, values })
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("預約成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reload();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])
            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            if (axiosMode !== "get") {
                setModalLoading(false)
                setModalOpen(false)
            }
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
            }
        }
    }
    const onRecordDelteClick = () => {
        Modal.confirm({
            width: 500,
            title: t('delete_record'),
            content: <>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                label={t('delete_borrower_record')}
                                name={fieldName ? [fieldName, "borrowernumber"].join('.') : "borrowernumber"}
                                rules={!hasValue ? [{ required: true, message: "請輸入" }] : []}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </>,
            onOk: () => {
                const values = form.getFieldsValue()
                deleteCheckoutHistoryData([
                    {
                        ...values,
                    }
                ])
            },
            okText: t('ok'),
            cancelText: t('cancel'),
        })
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected, selectedRows, changeRows
            })
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.key)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.key);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.key)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.key)
                selectRow = selectRow.filter(row => row.key !== record.key)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const getExcel = () => {
        axios.get('/library/koha/checkout/history/export/excel', {
            responseType: 'blob',
            params: {
                cur_page: 1,
                size: 1000,
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `借閱歷史.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    };
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    const {
        CheckoutData,
        getCheckoutHistoryData,
        postCheckoutRenewData,
        deleteCheckoutHistoryData,
    } = useCheckoutHistory({
        onBefore,
        onFinish: onRecordDelteFinish
    })
    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {
        },
        onFinish: () => {
        }
    })
    const {
        getCheckinData,
        postCheckinData,
    } = useCheckin({
        onBefore: () => { },
        onFinish: (value) => {
            const axiosMode = value?.axiosMode
            const axiosStatus = value?.status
            switch (axiosMode) {
                case 'post':
                    if (axiosStatus === 'success') toast.success('還書成功 !')
                    else if (value?.message === "Renewal not authorized (too_many)") toast.error('還書失敗 !')
                    else if (value?.message === "Renewal not authorized (on_reserve)") toast.error('還書失敗 !')
                    else toast.error('還書失敗 !')
                    actionRef.current.reloadAndRest()
                    break;
                default:
                    break;
            }
        },
    })

    useEffect(() => {
        if (borrowernumber)
            getBorrowerData({
                borrowernumber: borrowernumber
            })
    }, [borrowernumber])
    useEffect(()=>{
           actionRef.current.onTableSearch()
    },[search])

    const borrower = BorrowerData?.find(_ => true)

    return <>
        <ProTableOt
            searchParams={{
                itemnumber,
                barcode,
                biblionumber,
                ...search
            }}
            actionRef={actionRef}
            columns={columns}
            check={check}
            setCheck={setCheck}
            rowKey={'item_itemnumber'}
            request={async (params = {}, sort, filter) => {
                // setAxiosMode("get")
                let newParams = {
                    itemnumber,
                    barcode,
                    biblionumber,
                };
                const requestedOrder = setOrders(sort)
                const order = requestedOrder.length > 0
                    ? requestedOrder
                    : defaultOrder.map((item) => JSON.stringify(item))
                newParams = {
                    // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                    ...search
                    // borrowernumber: borrowernumber,
                    // cardnumber: "001"
                    // "categorycode": "TEST",
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                // setPageSize(params?.pageSize ?? 20)
                return getCheckoutHistoryData({
                    ...newParams
                })
            }}
            rowSelection={{
                selectedRowKeys: [],
                type: "checkbox",
                onSelectAll: rowSelection?.onSelectAll,
                onSelect: rowSelection?.onSelect,
                onChange: rowSelection?.getCheckboxProps

            }}
            toolBarRender={() => toolBarRender(permission_level === 1 ? [
                <Col span={24}>
                    <Row gutter={[4, 4]} align={"middle"}>
                        <Col>
                            <Typography.P>
                                {t(`return_time`)}:
                            </Typography.P>
                        </Col>
                        <Col>
                            <Input
                                type="date"
                                format={"YYYY-MM-DD"}
                                value={search?.date_return_start ? search?.date_return_start : ""}
                                onChange={(e) => {
                                    setSearch((pre) => {
                                        if (dayjs(e.target.value).isBefore(dayjs(pre?.date_return_end, "YYYY-MM-DD"))) {
                                            return {
                                                ...pre,
                                                date_return_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                date_return_start: pre?.date_return_end,
                                                date_return_end: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        <Col>
                            <Typography.Title level={4}>
                                ~
                            </Typography.Title>
                        </Col>
                        <Col>
                            <Input
                                type="date"
                                 format={"YYYY-MM-DD"}
                                value={search?.date_return_end ? search?.date_return_end : ""}
                                onChange={(e) => {
                                    setSearch((pre) => {
                                        if ((dayjs(e.target.value)).isBefore(pre?.date_return_start)) {
                                            return {
                                                ...pre,
                                                date_return_start: e.target.value,
                                                date_return_end: pre?.date_return_start,
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                date_return_end: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        {(search?.date_return_start || search.date_return_end) &&
                            <Col>
                                <Button
                                    type={"icon"}
                                    onClick={() => {
                                        setSearch((pre) => {
                                            return {
                                                date_return_start: undefined,
                                                date_return_end: undefined
                                            }
                                        })
                                    }}>
                                    X
                                </Button>
                            </Col>
                        }
                    </Row>
                </Col>,
                <Col span={24}>
                    <Row gutter={[4, 4]} align={"middle"}>
                        <Col>
                            <Typography.P>
                                {t(`borrow_date`)}:
                            </Typography.P>
                        </Col>
                        <Col>
                            <Input
                                type="date"
                                // granularity={"day"}
                                // placeholder={t(`.date_issue_start`)}
                                format={"YYYY-MM-DD"}
                                value={search?.date_issue_start ? search?.date_issue_start : ""}
                                onChange={(e) => {
                                    setSearch((pre) => {
                                        if (dayjs(e.target.value).isBefore(dayjs(pre?.date_issue_end, "YYYY-MM-DD"))) {
                                            return {
                                                ...pre,
                                                date_issue_start: dayjs(e.target.value).format("YYYY-MM-DD"),
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                date_issue_start: pre?.date_issue_end,
                                                date_issue_end: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        <Col>
                            <Typography.Title level={4}>
                                ~
                            </Typography.Title>
                        </Col>
                        <Col>
                            <Input
                                type="date"
                                placeholder={t(`.date_issue_end`)}
                                format={"YYYY-MM-DD"}
                                value={search?.date_issue_end ? search?.date_issue_end : ""}
                                onChange={(e) => {
                                    setSearch((pre) => {
                                        if ((dayjs(e.target.value)).isBefore(pre?.date_issue_start)) {
                                            return {
                                                ...pre,
                                                date_issue_start: e.target.value,
                                                date_issue_end: pre?.date_issue_start,
                                            }
                                        }
                                        else {
                                            return {
                                                ...pre,
                                                date_issue_end: e.target.value,
                                            }
                                        }

                                    })
                                }}
                            />
                        </Col>
                        {(search.date_issue_start || search.date_issue_end) &&
                            <Col>
                                <Button
                                    type={"icon"}
                                    onClick={() => {
                                        setSearch((pre) => {
                                            return {
                                                date_issue_start: undefined,
                                                date_issue_end: undefined
                                            }
                                        })
                                    }}>
                                    X
                                </Button>
                            </Col>
                        }
                    </Row>
                </Col>,
                <Button
                    type='text'
                    style={{
                        color: "#fff",
                        backgroundColor: "#56b673"
                    }}
                    onClick={() => {
                        getExcel()
                    }}
                >
                    匯出檔案
                </Button>,
                <Col span={24}>
                    <Button variant="destructive" onClick={() => {
                        onRecordDelteClick()
                    }}>{t("delete_record")}</Button>
                </Col>
            ] : [])}
        />
        {/* <Row gutter={[8, 8]}>
            <Col>
                <Button onClick={CheckIn} variant='outline' disabled={selectedRowsInfo.length === 0}><Icon.Checkin />{t("return_selected_items")}</Button>
            </Col>
            <Col>
                <Button onClick={Renew} variant='outline' disabled={selectedRowsInfo.length === 0}><Icon.Renew />{t("renew_selected_items")}</Button>
            </Col>
            <Col hidden>
                <Button onClick={() => { Renew() }} variant='outline' ><Icon.RenewAll />{t("renew_all_items")}</Button>
            </Col>
        </Row> */}
    </>
}
export default CheckoutsProTableOt
const Icon = () => { }
Icon.Checkin = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="16"
            version="1.1"
            viewBox="0 0 384 448"
        >
            <g stroke="none" strokeOpacity="1" transform="translate(0 -604.362)">
                <path
                    fillOpacity="1"
                    strokeDasharray="none"
                    strokeMiterlimit="4"
                    strokeWidth="64"
                    d="M0 988.362h384v64H0z"
                ></path>
                <path
                    fillRule="evenodd"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeWidth="1"
                    d="M160 604.362v192l-96-96v80l128 128 128-128v-80l-96 96v-192h-64z"
                ></path>
            </g>
        </svg>
    );
}
Icon.Renew = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
        >
            <path
                fill="#000"
                fillRule="evenodd"
                d="M12 6c-3.31 0-6 2.69-6 6h3l-4 4-4-4h3c0-4.42 3.58-8 8-8 1.57 0 3.03.46 4.26 1.24L14.8 6.7A5.87 5.87 0 0012 6zm3 6l4-4 4 4h-3c0 4.42-3.58 8-8 8a7.93 7.93 0 01-4.26-1.24L9.2 17.3c.83.45 1.79.7 2.8.7 3.31 0 6-2.69 6-6h-3z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}
Icon.RenewAll = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <g fill="#373737" strokeWidth="0.829" color="#000">
                <path
                    d="M8 11.141l-5.859-3.14 2.395-1.284-1.07-.574L0 8.001l8 4.286 8-4.286-3.465-1.858-1.068.574L13.861 8z"
                    style={{ InkscapeStroke: "none" }}
                ></path>
                <path
                    d="M8 14.854l-5.859-3.14 2.395-1.285-1.07-.573L0 11.714 8 16l8-4.286-3.465-1.858-1.068.573 2.394 1.285zM8 0L0 4.286l8 4.285 8-4.286zm0 1.146l5.86 3.14L8 7.426l-5.859-3.14z"
                    style={{ InkscapeStroke: "none" }}
                ></path>
            </g>
        </svg>
    );
}
